/* duck.icon.svg.js */

"use strict";
module.exports = {
    icon: `
            <svg viewBox="0 0 24 24" preserveAspectRatio="none">
                <path class="foreground-gl" d="M7.8,4.2C6.8,4.2,6,5,6,6s0.8,1.8,1.8,1.8S9.6,7,9.6,6S8.8,4.2,7.8,4.2 M9.6,0.6c3.3,0,6,2.7,6,6c0,2-1,3.8-2.6,4.9 c1.9,0.2,4,0.6,6.2,1.7c3.6,1.8,4.8-0.6,4.8-0.6s-1.2,10.8-8.4,10.8H8.4c0,0-6,0-6-6c0-3.6,3.6-4.8,2.4-7.2C0,10.2,0,6,0,6 c1.2,0.6,2.7,0.6,3.6,0.2C3.8,3.1,6.4,0.6,9.6,0.6z"/> 
            </svg>
        `,
};
